function PasswordGen(minLength = 8, maxLength = 15) {
    const lowercaseChars = 'abcdefghijklmnopqrstuvwxyz';
    const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';
    const symbols = '!@#$%^&*()-_+=';

    const length = Math.floor(Math.random() * (maxLength - minLength + 1)) + minLength;
    
    let password = '';
    
    const getRandomChar = (charSet) => {
      const randomIndex = Math.floor(Math.random() * charSet.length);
      return charSet[randomIndex];
    };
    
    // Add at least one lowercase letter
    password += getRandomChar(lowercaseChars);
    
    // Add at least one uppercase letter
    password += getRandomChar(uppercaseChars);
    
    // Add at least one number
    password += getRandomChar(numbers);
    
    // Add at least one symbol
    password += getRandomChar(symbols);
    
    // Fill the remaining characters with random characters from all character sets
    for (let i = password.length; i < length; i++) {
      const charSet = lowercaseChars + uppercaseChars + numbers + symbols;
      password += getRandomChar(charSet);
    }
    
    // Shuffle the password characters
    password = password.split('').sort(() => Math.random() - 0.5).join('');
    
    return password;
  }  

export default PasswordGen;